import React from "react";
import "./style.css";

export default function DashBlock({ data }) {
  return (
    <div className="d-flex dashboard_flex">
      {data &&
        data.map((item) => (
          <div className="card-layout col">
            <div className="dashboard-header">
              <h4 className="statheading">{item.heading}</h4>
            </div>

            <div class=" ">
              {item.items.slice(0, 7).map((item) => (
                <div className="d-flex justify-content-between p-2 border my-2">
                  <div className="statname">{item.name}</div>
                  <div className="statvalue" style={{ paddingLeft: "5px" }}>
                    {item.count}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}
